import api from '../lib/axios';

export const getTasks = (params) => api.get('/tasks', { params });
export const getTask = (id) => api.get(`/tasks/${id}`);
export const createTask = (data) => api.post('/tasks', data);
export const updateTask = (id, data) => api.patch(`/tasks/${id}`, data);
export const deleteTask = (id) => api.delete(`/tasks/${id}`);
export const addDependency = (taskId, data) => api.post(`/tasks/${taskId}/dependencies`, data);
export const removeDependency = (taskId, blockingTaskId) =>
  api.delete(`/tasks/${taskId}/dependencies/${blockingTaskId}`);
